"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("styled-components/macro");

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _ = require("../../");

var _Inputs = require("../styles/Inputs.styles");

var _Label = _interopRequireDefault(require("./Label"));

var _Errors = _interopRequireDefault(require("./Errors"));

var _validateInput = _interopRequireDefault(require("../validations/validateInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Bic = function Bic(_ref) {
  var id = _ref.id,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      validations = _ref.validations,
      onChange = _ref.onChange,
      dependencies = _ref.dependencies,
      isFirstInput = _ref.isFirstInput,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      noFocus = _ref.noFocus,
      t = _ref.t,
      validationDependency = _ref.validationDependency,
      errorHandler = _ref.errorHandler,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      customLabel = _ref.customLabel,
      postErrors = _ref.postErrors,
      postErrorHandler = _ref.postErrorHandler;
  var codeRefs = {};
  var bicFormatObject = {};
  var initialState = {};
  var bicFormatArray = ['AAAA', 'BB', 'CC', 'DDD'];
  var pos = 0;
  bicFormatArray.forEach(function (input) {
    var length = input.length;
    codeRefs[input] = /*#__PURE__*/(0, _react.createRef)();
    bicFormatObject[input] = input.length;
    initialState[input] = value.substr(pos, length);
    pos += length;
  });

  var _useReducer = (0, _react.useReducer)(function (state, newState) {
    return _objectSpread(_objectSpread({}, state), newState);
  }, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      bicCode = _useReducer2[0],
      setBicCode = _useReducer2[1];

  var bicCodeFullLength = Object.values(bicCode).join('').length;
  var validationDepKey, validationDepValue;

  if (validationDependency) {
    var _Object$values$;

    validationDepKey = Object.keys(validationDependency)[0];
    validationDepValue = (_Object$values$ = Object.values(validationDependency)[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$.toString();
  }

  var validationsArray = dependencies && dependencies[validationDepKey] && dependencies[validationDepKey][validationDepValue] ? (!value || value === '') && [].concat(_toConsumableArray(dependencies[validationDepKey][validationDepValue]), _toConsumableArray(validations || [])) : validations;

  var getRealValue = function getRealValue() {
    var realValue = '';
    Object.values(codeRefs).forEach(function (ref) {
      return realValue += ref.current.value;
    });
    return realValue;
  };

  var inputChangeHandler = function inputChangeHandler(_ref2) {
    var input = _ref2.input,
        e = _ref2.e;
    if (bicFormatObject[input] > bicCode[input].length) setBicCode(_defineProperty({}, input, e.target.value));
  };

  var onKeyDownHandler = function onKeyDownHandler(_ref3) {
    var input = _ref3.input,
        e = _ref3.e;

    if (e.keyCode === 8) {
      setBicCode(_defineProperty({}, input, bicCode[input].slice(0, -1)));
      var realValueLength = getRealValue().length;
      if (realValueLength <= 4) codeRefs[bicFormatArray[0]].current.focus();
      if (realValueLength > 4 && realValueLength <= 6) codeRefs[bicFormatArray[1]].current.focus();
      if (realValueLength > 6 && realValueLength <= 8) codeRefs[bicFormatArray[2]].current.focus();
      if (realValueLength > 8) codeRefs[bicFormatArray[3]].current.focus();
    } else {
      if (value.length === 4) codeRefs[bicFormatArray[1]].current.focus();
      if (value.length === 6) codeRefs[bicFormatArray[2]].current.focus();
      if (value.length === 8) codeRefs[bicFormatArray[3]].current.focus();
    }
  };

  var inputValidation = function inputValidation(valueToCheck) {
    (0, _validateInput.default)({
      value: valueToCheck,
      validations: validationsArray,
      validationDependency: validationDepValue,
      errorHandler: errorHandler,
      dependencies: dependencies,
      id: id
    });
  };

  (0, _react.useEffect)(function () {
    if (bicCodeFullLength <= 11) {
      if (postErrors) {
        postErrorHandler(id);
      }

      onChange(id, Object.values(bicCode).join(''));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [bicCodeFullLength]);
  (0, _react.useEffect)(function () {
    if (validationsArray) inputValidation(value); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  (0, _react.useEffect)(function () {
    if (dependencies) inputValidation(value); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validationDepValue]);
  (0, _react.useEffect)(function () {
    if (isFirstInput && !noFocus) codeRefs[bicFormatArray[0]].current.focus(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_Label.default, {
    customLabel: customLabel
  }), _react.default.createElement(_.FlexContainer, {
    alignItems: "center"
  }, bicFormatArray.map(function (input, i) {
    return _react.default.createElement(_Inputs.InputBlock, {
      type: "text",
      disableUnderline: true,
      inputRef: codeRefs[input],
      key: i,
      disabled: disabled,
      value: bicCode[input],
      width: "".concat(100 / bicFormatArray.length, "%"),
      onInput: function onInput(e) {
        return inputChangeHandler({
          input: input,
          e: e
        });
      },
      onKeyDown: function onKeyDown(e) {
        return onKeyDownHandler({
          input: input,
          e: e
        });
      }
    });
  })), _react.default.createElement(_Errors.default, {
    errors: postErrors ? [].concat(_toConsumableArray(errors), [postErrors.message]) : errors,
    t: t
  }));
};

var _default = _react.default.memo(Bic, _isEqual.default);

exports.default = _default;